import { render, staticRenderFns } from "./settlement-bill-edit.vue?vue&type=template&id=2b5972fb&scoped=true&"
import script from "./settlement-bill-edit.vue?vue&type=script&lang=ts&"
export * from "./settlement-bill-edit.vue?vue&type=script&lang=ts&"
import style0 from "./settlement-bill-edit.vue?vue&type=style&index=0&id=2b5972fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5972fb",
  null
  
)

export default component.exports